// Validation rules for page counts and compatibility
export const printingRules = {
  pageCount: {
    minimum: 4, // Global minimum page count
    maximum: 800, // Global maximum page count
    bindings: {
      'perfect-bound': { min: 40, max: 800 },
      'case-wrap': { min: 18, max: 800 },
      'linen-wrap': { min: 18, max: 800 },
    },
  },
  compatibility: {
    // Binding type compatibility with paper types
    paperByBinding: {
      'perfect-bound': [
        '60-cream-uncoated',
        '60-white-uncoated',
        '80-white-coated',
      ],
      'case-wrap': ['60-white-uncoated', '80-white-coated'],
      'linen-wrap': ['60-white-uncoated', '80-white-coated'],
    },
    // Cover finish compatibility with binding types
    coverByBinding: {
      'perfect-bound': ['glossy', 'matte'],
      'case-wrap': ['glossy', 'matte'],
      'linen-wrap': ['glossy', 'matte'],
    },
    // Linen options only available for linen-wrap binding
    linenByBinding: {
      'linen-wrap': [
        'red-linen',
        'navy-linen',
        'black-linen',
        'gray-linen',
        'tan-linen',
        'forest-linen',
      ],
    },
    // Foil options only available for linen-wrap binding
    foilByBinding: {
      'linen-wrap': ['gold-foil', 'black-foil', 'white-foil'],
    },
    // Paper type compatibility with color options
    paperByColor: {
      'standard-black': ['60-cream-uncoated', '60-white-uncoated'],
      'standard-color': ['60-white-uncoated', '80-white-coated'],
      'premium-color': ['80-white-coated'],
    },
    // Color printing compatibility with paper types
    colorByPaper: {
      '60-cream-uncoated': ['standard-black'],
      '60-white-uncoated': ['standard-black', 'standard-color'],
      '80-white-coated': ['standard-color', 'premium-color'],
    },
  },
};

export const bindingOptions = [
  {
    id: 'perfect-bound',
    type: 'binding',
    sku: 'PB',
    title: 'Perfect Bound',
    description: 'Professional paperback binding',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-binding-type-PB-1x.webp',
  },
  {
    id: 'case-wrap',
    type: 'binding',
    sku: 'CW',
    title: 'Case Wrap',
    description: 'Hardcover with printed cover',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-binding-type-CW-1x.webp',
  },
];

export const interiorColorOptions = [
  // {
  //   id: 'standard-black',
  //   type: 'interior',
  //   sku: 'BWSTD',
  //   title: 'Standard Black & White',
  //   description: 'Crisp black text and grayscale images',
  //   image:
  //     'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-interior-color-BWSTD-1x.webp',
  // },
  {
    id: 'standard-color',
    type: 'interior',
    sku: 'FCSTD',
    title: 'Standard Color',
    description: 'High-quality digital color printing',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-interior-color-FCSTD-1x.webp',
  },
  {
    id: 'premium-color',
    type: 'interior',
    sku: 'FCPRE',
    title: 'Premium Color',
    description: 'Superior color quality',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-interior-color-FCPRE-1x.webp',
  },
];

export const paperOptions = [
  /*
  {
    id: '60-cream-uncoated',
    type: 'paper',
    sku: '060UC444',
    title: '60# Cream - Uncoated',
    description: 'Natural cream paper',
    ppi: '444',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-paper-type-060UC-1x.webp',
  },
  {
    id: '60-white-uncoated',
    type: 'paper',
    sku: '060UW444',
    title: '60# White - Uncoated',
    description: 'Standard white paper',
    ppi: '444',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-paper-type-060UW-1x.webp',
  },
  */
  {
    id: '80-white-coated',
    type: 'paper',
    sku: '080CW444',
    title: '80# White - Coated',
    description: 'Premium coated paper',
    ppi: '444',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-paper-type-080CW-1x.webp',
  },
];

export const coverOptions = [
  {
    id: 'glossy',
    type: 'cover',
    sku: 'G',
    title: 'Glossy',
    description: 'Shiny, reflective finish',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-cover-finish-G-1x.webp',
  },
  {
    id: 'matte',
    type: 'cover',
    sku: 'M',
    title: 'Matte',
    description: 'Non-reflective finish',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-cover-finish-M-1x.webp',
  },
];

export const linenOptions = [
  {
    id: 'red-linen',
    type: 'linen',
    sku: 'R',
    title: 'Red Linen',
    description: 'Classic red linen cover',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-linen-R-1x.webp',
  },
  {
    id: 'navy-linen',
    type: 'linen',
    sku: 'N',
    title: 'Navy Linen',
    description: 'Deep navy linen cover',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-linen-N-1x.webp',
  },
  {
    id: 'black-linen',
    type: 'linen',
    sku: 'B',
    title: 'Black Linen',
    description: 'Classic black linen cover',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-linen-B-1x.webp',
  },
  {
    id: 'gray-linen',
    type: 'linen',
    sku: 'G',
    title: 'Gray Linen',
    description: 'Sophisticated gray linen cover',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-linen-G-1x.webp',
  },
  {
    id: 'tan-linen',
    type: 'linen',
    sku: 'T',
    title: 'Tan Linen',
    description: 'Warm tan linen cover',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-linen-T-1x.webp',
  },
  {
    id: 'forest-linen',
    type: 'linen',
    sku: 'F',
    title: 'Forest Linen',
    description: 'Rich forest green linen cover',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-linen-F-1x.webp',
  },
];

export const foilOptions = [
  {
    id: 'gold-foil',
    type: 'foil',
    sku: 'G',
    title: 'Gold Foil',
    description: 'Elegant gold foil stamping',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-foil-G-1x.webp',
  },
  {
    id: 'black-foil',
    type: 'foil',
    sku: 'B',
    title: 'Black Foil',
    description: 'Classic black foil stamping',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-foil-B-1x.webp',
  },
  {
    id: 'white-foil',
    type: 'foil',
    sku: 'W',
    title: 'White Foil',
    description: 'Modern white foil stamping',
    image:
      'https://assets.lulu.com/media/pricing-calculator/ProductOption/Book/lulu-book-foil-W-1x.webp',
  },
];
